import React from "react";

export default function FooterImpressumStatuten() {
    return  <div className="d-flex mt-4">
                <a rel="noreferrer" className="link-secondary text-uppercase text-center small" style={{letterSpacing: ".4px", flex: 1}} href="https://unisono-alumni.at/legal/imprint" target="_blank">Impressum</a>
                <a rel="noreferrer" className="link-secondary text-uppercase text-center small" style={{letterSpacing: ".4px", flex: 1}} href="https://unisono-alumni.at/legal/statutes" target="_blank">Statuten</a>
                <a rel="noreferrer" className="link-secondary text-uppercase text-center small" style={{letterSpacing: ".4px", flex: 1}} href="https://unisono-alumni.at/legal/privacy" target="_blank">Datenschutz</a>
            </div>
}